import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    color: PropTypes.oneOf(['primary', 'premium', 'error', 'secondary', 'facebook']),
    expand: PropTypes.bool,
    loading: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'button',
    color: 'primary',
    expand: false,
    loading: false,
    type: 'button',
};

class Button extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            color,
            disabled,
            expand,
            loading,
        } = this.props;
        return [
            'c-btn',
            `c-btn--${color}`,
            disabled ? 'c-btn--disabled' : false,
            expand ? 'c-btn--fluid' : false,
            loading ? 'c-btn--loading' : false,
            className,
        ];
    }

    renderChildren() {
        const {
            children,
            loading,
        } = this.props;
        if (!loading) {
            return children;
        }
        return (
            <>
                {children}
                <div className="s-loader">
                    <div className="s-loader__round" />
                    <div className="s-loader__border" />
                </div>
            </>
        );
    }

}

Button.propTypes = propTypes;

Button.defaultProps = defaultProps;

export default Button;
